import type { SearchResponse, SearchType } from '@brandschutz/shared';
import { api } from '@/lib/api';

export async function search(q: string, types?: SearchType[], limit = 6): Promise<SearchResponse> {
  const { data } = await api.get<SearchResponse>('/search', {
    params: { q, types: types?.join(','), limit },
  });
  return data;
}
